export const bonus = [
  {
    title: '',
    video: './img/order/video_1.webm',
    alt: '',
    poster: './img/cover/video_cover.webp'
  },
  {
    title: '',
    video: './img/order/video_2.webm',
    alt: '',
    poster: './img/cover/video_cover.webp'
  }
]

export const preface = {
  title: 'Notre vision du jeu',
  img: './img/order/preorder.webp',
  alt: 'SeedOut Fenua manette nintendo'
}

export const preorder = {
  title: 'Commandez SeedOut Fenua dès maintenant',
  img: './img/order/preorder_card.webp',
  alt: 'SeedOut Fenua boitier de jeu Android Apple'
}
